'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, useEffect, useRef, useState } from 'react';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { TabGroup } from '@sola/ark-core/molecules/tab-group/tab-group.tsx';
import { BlockProps } from '@sola/schema/lib/schema.ts';
import { ReviewsList } from '../../molecules/reviews-list/reviews-list.tsx';
type Review = {
  firstname: string;
  Sponsor: string;
  location: string;
  headline: string;
  Comments: string;
  overall: string;
  recommend: string;
};
const ReviewsInternal: React.ComponentType<BlockProps> = () => {
  const reviewsRef = useRef<null | HTMLDivElement>(null);
  const [reviews, setCurrentReviews] = useState<Review[]>([]);
  const updatePage = async (page: number, rating?: number) => {
    if (page !== 0) {
      const dataPages = (await import('./reviews-data-pages')).default;
      setCurrentReviews(dataPages[`page${page}` as keyof typeof dataPages].reviews);
    } else {
      const data = (await import('./reviews-data')).default;
      if (rating) {
        setCurrentReviews(data[`rating${rating}` as keyof typeof data].reviews);
      } else {
        setCurrentReviews(data.rating5.reviews);
      }
    }
    reviewsRef.current?.scrollIntoView({
      behavior: 'instant'
    });
  };
  useEffect(() => {
    updatePage(0);
  }, []);
  return <section className="ReviewsMain component component--no-header" ref={reviewsRef}>
      <div className="ReviewsMain__container container">
        <div className="ReviewsMain">
          <TabGroup activeValue="0" onChange={e => {
          const rate = Number(e);
          switch (rate) {
            case 0:
              updatePage(0);
              break;
            default:
              updatePage(0, rate);
              break;
          }
        }} items={[{
          body: <ReviewsList reviews={reviews} updatePage={updatePage} />,
          tabKey: '0',
          title: 'View All'
        }, {
          body: <ReviewsList reviews={reviews} updatePage={updatePage} rating={5} />,
          tabKey: '5',
          title: '5-Star (627)'
        }, {
          body: <ReviewsList reviews={reviews} updatePage={updatePage} rating={4} />,
          tabKey: '4',
          title: '4-Star (21)'
        }, {
          body: <ReviewsList reviews={reviews} updatePage={updatePage} rating={3} />,
          tabKey: '3',
          title: '3-Star (14)'
        }, {
          body: <ReviewsList reviews={reviews} updatePage={updatePage} rating={2} />,
          tabKey: '2',
          title: '2-Star (7)'
        }, {
          body: <ReviewsList reviews={reviews} updatePage={updatePage} rating={1} />,
          tabKey: '1',
          title: '1-Star (19)'
        }]} title="Tab Options" />
        </div>
      </div>
    </section>;
};
export const Reviews: React.ComponentType<BlockProps> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Suspense fallback={t0}><ReviewsInternal {...props} /></Suspense>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};